import React from 'react';
import cx from 'classnames';
import {Title, Text, Flex} from '@priority-software/priority-style-react';
import {Content} from '../../../TabsContent/Content';
import {Footer} from '../../../TabsContent/Footer';
import {SubmitButton} from '../../../../components';
import texts from '../../../../texts';
import img from './../../../../../../images/finalQuiz.png';
import styles from './style.module.scss';

type Props = {
    goToNextTab: () => void;
};

export const FinalPage = ({goToNextTab}: Props) => {
    return (
        <div className={cx(styles.component)}>
            <div className="tabHeader">
                <Title skin="h3" textColor="primary-500" componentClasses="tabTitle">
                    {texts.general_info_tab_title}
                </Title>
            </div>

            <Content>
                <div className={styles.content}>
                    <img src={img} alt="final-Priority" />
                    <Title
                        componentClasses={styles.title}
                        text={texts.general_info_tab_success_title}
                        textColor="primary-700"
                        skin="h2"
                    />
                    <Text
                        componentClasses={styles.text}
                        tag="p"
                        skin="paragraph-1"
                        textColor="primary-700"
                    >
                        {texts.general_info_tab_success_text}
                    </Text>
                </div>
            </Content>

            <Footer>
                <Flex justifyContent="flex-end">
                    <SubmitButton onClick={goToNextTab}>
                        {texts.general_info_tab_success_btn}
                    </SubmitButton>
                </Flex>
            </Footer>
        </div>
    );
};
